"use client";

import Link from "next/link";
import { useSearchParams } from "next/navigation";
import PhotoEditorCatalogDashboard from "@/components/dashboard/catalog/PhotoEditorCatalogDashboard";
import HeroPromptStudio from "./HeroPromptStudio";
import HeroBento from "./HeroBento";
import HeroWhatsNew from "./HeroWhatsNew";
import HeroSpotlight from "./HeroSpotlight";

const VARIANTS = [
  { id: "a", label: "A · Prompt studio" },
  { id: "b", label: "B · Bento" },
  { id: "c", label: "C · What's new" },
  { id: "d", label: "D · Spotlight" },
  { id: "live", label: "Current" },
] as const;

type VariantId = (typeof VARIANTS)[number]["id"];

function resolveVariant(raw: string | null): VariantId {
  return VARIANTS.some((v) => v.id === raw) ? (raw as VariantId) : "a";
}

export default function HeroLab() {
  const variant = resolveVariant(useSearchParams().get("v"));

  const hero =
    variant === "a" ? (
      <HeroPromptStudio />
    ) : variant === "b" ? (
      <HeroBento />
    ) : variant === "c" ? (
      <HeroWhatsNew />
    ) : variant === "d" ? (
      <HeroSpotlight />
    ) : undefined;

  return (
    <>
      <PhotoEditorCatalogDashboard key={variant} hero={hero} hideLeadBanner={variant === "d"} />
      <div
        className="fixed bottom-4 left-1/2 z-50 flex max-w-[calc(100vw-1rem)] -translate-x-1/2 gap-1 overflow-x-auto rounded-full bg-gray-900/95 p-1 shadow-xl backdrop-blur"
        style={{ scrollbarWidth: "none" }}
      >
        {VARIANTS.map((v) => (
          <Link
            key={v.id}
            href={`?v=${v.id}`}
            scroll={false}
            className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-semibold transition ${
              v.id === variant ? "bg-white text-gray-900" : "text-white/75 hover:text-white"
            }`}
          >
            {v.label}
          </Link>
        ))}
      </div>
    </>
  );
}
